import { Component } from 'react';
import { Heading, Container, Box } from 'roo-ui/components';
import PropTypes from 'prop-types';

import LoadingPage from 'pages/LoadingPage';
import { ConnectedGatekeeperLoginForm } from './GatekeeperLoginForm';
import QFFWidgetLoginForm from './QFFWidgetLoginForm';
import NoAccessAlert from './NoAccessAlert';
import NonMemberInfo from './NonMemberInfo';

const QFF_LOGIN_WIDGET_PADDING = '15px';

class LoginPage extends Component {
  renderLoginForm() {
    const { isSSO, bookingId } = this.props;

    if (isSSO) {
      return <QFFWidgetLoginForm />;
    }

    if (!bookingId) {
      return <NoAccessAlert mt={9} />;
    } else {
      return <ConnectedGatekeeperLoginForm bookingId={bookingId} />;
    }
  }

  render() {
    const { isSSO, hasInitializedSSO } = this.props;

    if (isSSO && !hasInitializedSSO) {
      return <LoadingPage />;
    }

    return (
      <Container pt={9} pb={9} maxWidth="login">
        <Box mx={QFF_LOGIN_WIDGET_PADDING}>
          <Heading.h1 fontSize={['2xl', '3xl']}>Manage your hotel bookings</Heading.h1>
          <NonMemberInfo bookingId={this.props.bookingId} />
        </Box>
        {this.renderLoginForm()}
      </Container>
    );
  }
}

LoginPage.propTypes = {
  isSSO: PropTypes.bool,
};

LoginPage.defaultProps = {
  isSSO: false,
};

export default LoginPage;
